export const BOOSTERS_TYPES = {
  FIFTY_FIFTY: 'FIFTY_FIFTY',
  HINT: 'HINT',
  SKIP: 'SKIP',
  PLUS_FIVE_SECS: 'PLUS_FIVE_SECS',
  SECOND_CHANCE: 'SECOND_CHANCE',
};
